module.exports = __webpack_public_path__ + "static/media/email-footer.76f84733.svg";